<script setup lang="ts">
import { usePlayerFlagsStore } from '@/stores/playerFlagsStore.ts'
import { useGameStore } from '@/stores/gameStore.ts'
import { usePlanetStore } from '@/stores/planetStore.ts'
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import Alert from '@/components/Elements/Alerts/Alert.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import GenericIcon from '@/components/Elements/Images/Icons/GenericIcon.vue'
import { handleNext } from '../tutorialSteps'

const playerFlagsStore = usePlayerFlagsStore()
const route = useRoute()
const router = useRouter()

const handleNextStep = async () => {
  await handleNext('tutorial_planet_population')
}

const isOnPlanetsSection = computed(() => {
  return route.path.startsWith('/planets')
})

const goToPlanets = () => {
  router.push('/planets')
}

</script>

<template>
  <TutorialFrame
    video-url="https://cdn.ferion.com/videos/advisors/temperate/planet.webm"
  >
    <template #text>
      <p class="pb-2">
        Population is the lifeblood of your empire. Your citizens work in farms, factories, and research facilities to produce resources.
      </p>
      <p class="pb-2">
        The more population a planet has the more productive your empire will be. The population will grow automatically when you have a surplus of food <GenericIcon type="food" />.
      </p>
      <p class="pb-2">
        You can assign to have your population work on food <GenericIcon type="food" />, production <GenericIcon type="production" /> or science <GenericIcon type="science" />.
      </p>
    </template>

    <template #alerts>
      <Alert type="info" class="mb-2">
        Click on the "Stats" tab, and then change the "Farmers", "Workers", "Scientists" sliders and see the effect they have on your <GenericIcon type="food" />, <GenericIcon type="production" />, <GenericIcon type="science" /> output.
      </Alert>
    </template>

    <template #buttons>
      <ActionButton v-if="!isOnPlanetsSection" @click="goToPlanets" class="mr-2">
        Goto Planets
      </ActionButton>
      <ActionButton @click="handleNextStep">
        I got it
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss"></style>